const Config = require('~/config/default.env').default;

export default {
  state: {
    beautyProfileStep: {
      current: 1,
      total: 3,
    },
    newsletter: '',
    newsletterDefault: ['sociolla', 'soco', 'lilla', 'beauty_journal'],
    newsletterSet: false,
    newsletterLoading: false,
    lilla: {
      gender: 'Female',
      children: [],
      children_public: false,
      total_children: 0,
      is_mother: '',
      totalAnswered: 0,
      avatar: [
        'https://s3-ap-southeast-1.amazonaws.com/images.soco.id/lulla-images/avatar-1.svg',
        'https://s3-ap-southeast-1.amazonaws.com/images.soco.id/lulla-images/avatar-2.svg',
        'https://s3-ap-southeast-1.amazonaws.com/images.soco.id/lulla-images/avatar-3.svg',
        'https://s3-ap-southeast-1.amazonaws.com/images.soco.id/lulla-images/avatar-4.svg',
        'https://s3-ap-southeast-1.amazonaws.com/images.soco.id/lulla-images/avatar-5.svg',
        'https://s3-ap-southeast-1.amazonaws.com/images.soco.id/lulla-images/avatar-6.svg',
      ],
    },
  },
  mutations: {
    setBeautyProfileStep(state, step) {
      state.beautyProfileStep.current = step;
    },
    setChildrenData(state, payload) {
      if (state.lilla.children.length) {
        Object.assign(state.lilla.children[payload.index], { ...payload });
      }
    },
    setLillaProfile(state, data) {
      Object.assign(state.lilla, data);
    },
    setTotalAnsweredLilla(state, value) {
      state.lilla.totalAnswered = value;
    },
    newsletter(state, data) {
      state.newsletter = data;
    },
    newsletterSet(state, data) {
      state.newsletterSet = data;
    },
    newsletterLoading(state, value) {
      state.newsletterLoading = value;
    },
  },
  getters: {
    userProfile(state, getters, { userProfile }) {
      return userProfile;
    },
    isFemale(state, { userProfile }) {
      return Boolean(userProfile.gender && userProfile.gender.toLowerCase() === 'female');
    },
    isMother(state, { userProfile }) {
      return Boolean(Object.keys(userProfile).indexOf('is_mother') > -1 && userProfile.is_mother != '');
    },
    hasLillaProfile(state, { isMother, userProfile }) {
      return Boolean(isMother && userProfile.is_mother.length > 0);
    },
  },
  actions: {
    fetchNewsletter({ state: { newsletterDefault }, commit, getters: { userProfile }, rootState: { user_id } }) {
      return axios
        .get(Config.MS_SOCO_PUBLIC_API_URL + '/users', {
          params: {
            filter: {
              _id: `${user_id || userProfile._id}`,
            },
            fields: 'subscribings,is_subscribings_set',
          },
        })
        .then(function (response) {
          if (response.status === 200 && response.data.data && response.data.data[0]) {
            const subscribings = response.data.data[0].subscribings;
            const isSubscribingSet = response.data.data[0].is_subscribings_set;
            commit('newsletter', isSubscribingSet ? subscribings : newsletterDefault);
            commit('newsletterSet', isSubscribingSet);
          }
          return response.status === 200;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    registerNewsletter({ state: { newsletter, newsletterSet } }, data) {
      const payload = {
        subscribings: newsletter,
      };
      if (!newsletterSet) {
        payload['is_subscribings_set'] = true;
      }
      return axios
        .post(Config.MS_SOCO_PUBLIC_API_URL + '/user/me/preferences', payload)
        .then((response) => {
          return response && response.status === 200;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    submitBeautyProfile({
      state: {
        lilla: { gender, children, children_public, total_children, is_mother },
      },
      getters: { userProfile },
      rootState: { user_id },
    }) {
      return axios
        .put(Config.MS_SOCO_PUBLIC_API_URL + `/users/${user_id || userProfile._id}`, {
          gender,
          children_public,
          total_children,
          is_mother,
          children: children.map((child) => {
            return {
              ...child,
              year_of_birth: new Date(child.year_of_birth).getFullYear(),
            };
          }),
        })
        .then(function (response) {
          return Boolean(response && response.status === 200);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
